export const UI_VARIANTS = {
  classic: 'classic',
  redesign: 'redesign',
} as const;

export type UIVariant = (typeof UI_VARIANTS)[keyof typeof UI_VARIANTS];

export const DEFAULT_UI_VARIANT: UIVariant = UI_VARIANTS.classic;

export const REDESIGN_SURFACE_CLASS = 'guestapp-redesign';

const QUERY_PARAM = 'guestapp_redesign_enabled';
const REDESIGN_FLAG_STORAGE_KEY = 'FEATURE_TOGGLE__GUESTAPP_REDESIGN_ENABLED';

export const applyUIVariantQueryOverride = (): void => {
  try {
    const fromQuery = new URLSearchParams(window.location.search).get(QUERY_PARAM);
    if (fromQuery === 'true' || fromQuery === 'false') {
      window.localStorage.setItem(REDESIGN_FLAG_STORAGE_KEY, fromQuery);
    }
  } catch {
    /* ignore storage/URL access errors */
  }
};
